import { MODEL_NAMES } from '../constants/index';
import Model, { attr, hasMany } from '@ember-data/model';

export const EXTERNAL_SCOPE_TYPES = {
  client: 'Client',
  system: 'System',
  user: 'User',
};

export default class MessagingUserModel extends Model {
  @hasMany(MODEL_NAMES.CONVERSATION, { async: true, inverse: null }) conversations;
  @hasMany(MODEL_NAMES.MESSAGE, { async: true, inverse: null }) messages;

  @attr('boolean') isAway;

  @attr('string') awayMessageText;
  @attr('string') externalId;
  @attr('string') externalScope;
  @attr('string') name;
  @attr('string') organizationId;

  get isSystemUser() {
    return (
      this.organizationId === '0' &&
      this.externalId === '0' &&
      this.externalScope === 'System' &&
      this.name === 'System'
    );
  }
}
